/**
 * An action containing common properties for buttons, kebabs, etc.
 */
var Action = /** @class */ (function () {
    function Action() {
    }
    return Action;
}());
export { Action };
//# sourceMappingURL=action.js.map